import {RepositoryNotLoading, RepositoryWithLoading} from "./Repository";

const resource = 'v2/orders';
export default {
    create(data) {
        return RepositoryNotLoading.post(`${resource}/create`, data);
    },
    single(id) {
        return RepositoryWithLoading.get(`${resource}/${id}`);
    },
    list(params) {
        return RepositoryWithLoading.get(`${resource}`, {params});
    },
    loadMore(params) {
        return RepositoryNotLoading.get(`${resource}`, {params});
    },
    reject(order_id, reason) {
        return RepositoryNotLoading.post(`${resource}/reject`, {order_id, reason});
    },
    takePaymentInfo(data) {
        return RepositoryNotLoading.post(`${resource}/take-payment-info`, data);
    },
    getPaymentMethods(totalTickets, scheduleId) {
        return RepositoryNotLoading.get(`${resource}/payment-methods`, {params: {total_tickets: totalTickets, schedule_id: scheduleId}});
    }
}
